import { Outlet, createRootRouteWithContext } from '@tanstack/react-router'
// import { TanStackRouterDevtools } from '@tanstack/react-router-devtools'
// import TanStackQueryLayout from '../integrations/tanstack-query/layout.tsx'

import type { QueryClient } from '@tanstack/react-query'
import NavBar from '@/components/NavBar.tsx'
import Auth from '@/components/Auth'
import { ErrorBoundary } from '@sentry/react'
import { ErrorLayout } from '@/layout/ErrorLayout'
import BottomTabBar from '@/components/TabBar'
import { useRefreshFnStore } from '@/store'
import { PullToRefresh } from 'antd-mobile'
import ShadowBall from '@/components/ShadowBall'
import OrderCountdownFloat from '@/components/OrderCountdownFloat'
interface MyRouterContext {
  queryClient: QueryClient
}
export const Route = createRootRouteWithContext<MyRouterContext>()({
  component: () => {
    const refreshFn = useRefreshFnStore((state) => state.refreshFn)
    return (
      <PullToRefresh onRefresh={refreshFn}>
        <Auth>
          <div className="flex flex-col min-h-screen">
            <NavBar />
            <div className="flex-1 overflow-auto">
              <ErrorBoundary
                fallback={() => {
                  return <ErrorLayout />
                }}
              >
                <Outlet />
              </ErrorBoundary>
            </div>
            <BottomTabBar />
            <ShadowBall />
            <OrderCountdownFloat />
            {/* <TanStackRouterDevtools /> */}
            {/* <TanStackQueryLayout /> */}
          </div>
        </Auth>
      </PullToRefresh>
    )
  },
})
